import Cookies from "js-cookie";
import axios from "./config";
import { jwtDecode } from "jwt-decode";

interface DecodedToken {
  emp_id: string;
}

export function getHeader() {
  const token = Cookies.get("token") || "";
  const header = {
    Authorization: token,
  };
  return header;
}

const getUserInfo = () => {
  const token = Cookies.get("token");

  if (!token) {
    throw new Error("Authorization token not found");
  }

  return jwtDecode<DecodedToken>(token);
};

export const getAllConfig = async (
  page: number,
  size: number,
  params: any
): Promise<any> => {
  let url = `/admin/configs`;
  const response = await axios.get<any>(url, {
    headers: getHeader(),
  });
  return response.data;
};

export const addNewConfig = async (formData: FormData): Promise<any> => {
  let url = `/admin/configs`;
  const response = await axios.post<any>(url, formData, {
    headers: getHeader(),
  });
  return response.data;
};

export const deleteConfig = async (id: number): Promise<any> => {
  let url = `/admin/configs/${id}`;
  const response = await axios.delete<any>(url, {
    headers: getHeader(),
  });
  return response.data;
};

export const editConfig = async (id: number, formData: any): Promise<any> => {
  let url = `/admin/configs/${id}`;
  const response = await axios.put<any>(url, formData, {
    headers: getHeader(),
  });
  return response.data;
};

export const singleConfig = async (id: number): Promise<any> => {
    let url = `/admin/configs/${id}`;
    const response = await axios.get<any>(url, {
      headers: getHeader(),
    });
    return response.data;
  };
